import { render } from "./SurveyTaker.vue?vue&type=template&id=11708e8e"
import script from "./SurveyTaker.vue?vue&type=script&lang=js"
export * from "./SurveyTaker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__